import {
  Component,
  EventEmitter,
  Injectable,
  Injector,
  OnInit,
  OnDestroy,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { UploadService } from '../../../../common/services/Upload.service';
import { ConfirmationService } from 'primeng/primeng';
import { EvsProductService } from '../../../../common/services/EvsProduct.service';
import { UtilityService } from '../../../../common/services/Utility.service';
import { Location } from '@angular/common';
import { CategoryService } from '../../../../common/services/Category.service';
import { IOption } from 'ng-select';
import { ToastrService } from 'ngx-toastr';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ImageService } from '../../../imageService';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { error } from 'protractor';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;
let that: any;

@Component({
  moduleId: module.id,
  selector: 'evs_product_add',
  templateUrl: './product_add.component.html',
  styleUrls: ['./product.css'],
  providers: [ConfirmationService, EvsProductService, EvsAddressService],
})
@Injectable()
export class EvsProductAddComponent implements OnInit, OnDestroy {
  @Output('backToList') backToList = new EventEmitter();
  @ViewChild('uploadImageCke') uic: ElementRef;

  title = 'Thêm mới sản phẩm';
  public productForm: FormGroup;
  public product: any = {
    images: [],
    display_name: '',
    is_maintenance_reminder: false,
    is_extend_maintenance: false,
    maintenance_mode: 'once',
    maintenance_cycle: null,
    maintenance_cycle_unit: 'months',
    is_expired_reminder: false,
    expired_mode: 'once',
    expired_cycle: null,
    expired_cycle_unit: 'months',
    extend_limit: null
  };
  public is_use_time: Boolean = false;
  public id = '';
  public message: { class: string; content: string } = null;
  public titleFile = 'Chọn file upload';
  public error = '';
  public files: any = null;
  // public cateList: Array<Object> = [];
  public cateList: Array<IOption> = [];
  public cateList2: Array<IOption> = [];
  public cateList3: Array<IOption> = [];
  public messageErrorImage = '';

  private attachments: any[] = [];
  public listImg: any[];
  public filesThumb: any;
  public thumb = '';
  public proContent = '';
  isTrueSize: Boolean = true;

  barcode: any;
  vendors: any = [];
  vendor: any = {};
  vendorAdd: any = {};
  isAddVendor: Boolean = false;
  cities: any = [];
  districts: any = [];
  vendorAddressShow: any;
  productAttributes: any = [];
  idInfo: any = 0;
  currentNumberImage: any = 0;

  listIndexImage: any = [];
  listInfos: any = [];
  countries: Array<IOption> = [];
  selectedCountry: any = '241';

  filesAttach: any = [];
  filesAttachFake: any = [];
  filesAttachName: any = [];
  filesAttachNameFake: any = [];

  isAdding: Boolean = false;

  ckeConfig: any;
  modalRef: BsModalRef;

  langSubscription: Subscription;
  placeholders: any = {};
  currentLang: string = 'vi';

  constructor(
    private injector: Injector,
    private _location: Location,
    private productService: EvsProductService,
    private upload: UploadService,
    private cate: CategoryService,
    private _fb: FormBuilder,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private addressService: EvsAddressService,
    private imageService: ImageService,
    private modalService: BsModalService,
    private translate: TranslateService
  ) {
    that = this;
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  currentContentIndex: any = null;

  ngOnInit() {
    this.createForm();

    this.currentLang = this.translate.currentLang || 'vi';
    this.updatePlaceholders();
    this.langSubscription = this.translate.onLangChange.subscribe((event: any) => {
      this.currentLang = event.lang;
      this.updatePlaceholders();
    });
    //this.getListCategory();
    this.loadListVendor();
    this.getCountries();
    // setTimeout(() => {
    //   $('#vendor_id').select2({
    //     placeholder: '-- Chọn trạng thái --',
    //     allowClear: true,
    //   });
    // }, 1000)
    this.ckeConfig = {
      allowedContent: false,
      forcePasteAsPlainText: true,
      font_names: 'Arial;Times New Roman;Verdana',
      extraPlugins: 'iframe',
      toolbarGroups: [
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'clipboard', groups: ['clipboard', 'undo'] },
        {
          name: 'editing',
          groups: ['find', 'selection', 'spellchecker', 'editing'],
        },
        { name: 'forms', groups: ['forms'] },
        '/',
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        {
          name: 'paragraph',
          groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'],
        },
        { name: 'links', groups: ['links'] },
        { name: 'insert', groups: ['insert'] },
        '/',
        { name: 'styles', groups: ['styles'] },
        { name: 'colors', groups: ['colors'] },
        { name: 'tools', groups: ['tools'] },
        { name: 'others', groups: ['others'] },
        { name: 'about', groups: ['about'] },
      ],
      removeButtons:
        'Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Strike,Subscript,Superscript,CopyFormatting,RemoveFormat,Outdent,Indent,CreateDiv,Blockquote,BidiLtr,BidiRtl,Language,Unlink,Anchor,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About',
    };

    $('.cke_button__image').hide();

    setTimeout(() => {
      $('.cke_button__image').hide();
      $(`.test${this.arrContent[0].id} .cke_button__link`)
        .parent()
        .append(
          `<a style="display: inline-block;padding: 4px;"><span class="cke_button_icon cke_button__image_icon" style="background-image:url('https://cdn.ckeditor.com/4.14.0/standard-all/plugins/icons.png?t=K24B');background-position:0 -1224px;background-size:auto;">&nbsp;</span></a>`
        );
      $(
        `.test${this.arrContent[0].id} .cke_button_icon.cke_button__image_icon`
      ).click((event) => {
        this.currentContentIndex = 0;
        this.modalRef = this.modalService.show(this.uic);
      });
    }, 500);
  }

  updatePlaceholders() {
    this.translate.get([
      'PT_NHAP_BARCODE_SP',
      'PT_NHAP_THONG_TIN_DN',
      'PT_CHON_QUOC_GIA'
    ]).subscribe((t: any) => {
      this.placeholders = {
        barcode: t['PT_NHAP_BARCODE_SP'],
        vendorDesc: t['PT_NHAP_THONG_TIN_DN'],
        country: t['PT_CHON_QUOC_GIA']
      };
    });
  }

  currentIndex: any = null;

  backToComponent() {
    this.resetForm();
    this.backToList.emit({
      isBack: true,
    });
    //this._location.back();
  }

  getListCategory() {
    // this.cate
    //   .all()
    //   .toPromise()
    //   .then((cat) => {
    //     const cateList = [];
    //     cat.forEach((c: any) => {
    //       cateList.push({
    //         value: c.id,
    //         label: c.name,
    //       });
    //     });
    //     this.cateList = cateList;
    //   });
  }

  onDeselected(item, type) {
    if (type === 1) {
      this.cateList2 = [];
      this.cateList3 = [];
      (<FormControl>this.productForm.controls['cate_id1']).setValue(null, {
        onlySelf: true,
      });
      (<FormControl>this.productForm.controls['cate_id2']).setValue(null, {
        onlySelf: true,
      });
    } else if (type === 2) {
      this.cateList3 = [];
      (<FormControl>this.productForm.controls['cate_id2']).setValue(null, {
        onlySelf: true,
      });
    }
  }

  loadCateList(val, mode) {
    // this.cate
    //   .all({ parent_id: val.value })
    //   .toPromise()
    //   .then((cate) => {
    //     const cat1 = cate[0];
    //     const cateList = [];
    //     cate.forEach((cat) => {
    //       cateList.push({
    //         value: cat.id,
    //         label: cat.name,
    //       });
    //     });
    //     if (mode === 2) {
    //       this.cateList2 = cateList;
    //       this.cateList3 = [];
    //       (<FormControl>this.productForm.controls["cate_id1"]).setValue(null, {
    //         onlySelf: true,
    //       });
    //       (<FormControl>this.productForm.controls["cate_id2"]).setValue(null, {
    //         onlySelf: true,
    //       });
    //     } else if (mode === 3) {
    //       this.cateList3 = cateList;
    //     } else {
    //       this.cateList = cateList;
    //     }
    //   });
  }

  createForm() {
    this.productForm = this._fb.group({
      sku: [null, [Validators.required]],
      name: [null, [Validators.required]],
      video: [null],
      price: [null],
      vendor_id: [null],
      vendor_gln_code: [null],
      vendor_name: [null],
      vendor_country: [null],
      vendor_address: [null],
      vendor_districts: [null],
      vendor_city: [null],
      vendor_phone: [null],
      vendor_email: [null],
      vendor_website: [null],
      vendor_description: [null],
      is_use_time: [false],
      use_time_count: [null],
      use_time_type: [null],
      ckeContent: [null],
      is_maintenance_reminder: [false],
      maintenance_mode: ['once'],
      maintenance_cycle: [],
      maintenance_cycle_unit: ['months'],
      is_extend_maintenance: [false],
      extend_limit: [],
      is_expired_reminder: [false],
      expired_mode: ['once'],
      expired_cycle: [],
      expired_cycle_unit: ['months'],
    });
  }

  reset() {
    $('#previewThumb').html('');
    $('#previewImage').html('');
    this.cateList2 = [];
    this.cateList3 = [];
    this.productForm.reset();
    (<FormControl>this.productForm.controls['description']).setValue(null, {
      onlySelf: true,
    });
  }

  processSave() {
    // this.message = {
    //     class: 'alert dark alert-info',
    //     content: 'Đang thực thi...'
    // };
  }

  onSubmit(data: any) {
    this.scrollToTop();

    if (data.is_maintenance_reminder) {
      if (!data.maintenance_cycle || parseInt(data.maintenance_cycle, 10) <= 0) {
        this.toastr.warning('Vui lòng nhập thời gian thông báo bảo trì lớn hơn 0', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return;
      }
    }

    if (data.is_expired_reminder) {
      if (!data.expired_cycle || parseInt(data.expired_cycle, 10) <= 0) {
        this.toastr.warning('Vui lòng nhập thời gian thông báo hết hạn bảo hành lớn hơn 0', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return;
      }
    }

    if (data.is_extend_maintenance && data.maintenance_mode === 'recurring') {
      if (!data.extend_limit || parseInt(data.extend_limit) <= 0) {
        this.toastr.warning('Vui lòng nhập giới hạn số lần gửi sau khi hết hạn BH lớn hơn 0', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return;
      }
    }

    this.processSave();
    this.listImg = [];

    if (!data.price) {
      delete data.price;
    } else if (parseInt(data.price) <= 0) {
      this.message = {
        class: 'alert dark alert-warning',
        content: 'Vui lòng nhập giá sản phẩm lớn hơn 0',
      };
      return;
    }
    // if(!data.cate_id2){
    //     delete data.cate_id2;
    // }

    if (!this.filesThumb && !this.thumb) {
      this.message = {
        content: 'Bạn chưa chọn ảnh thumb.',
        class: 'alert-danger',
      };
      return;
    }
    if (this.isTrueSize == true) {
      if ((this.files && this.files.length > 0) || this.filesThumb) {
        if (this.files && this.files.length > 0) {
          this.listImg = this.files;
        }
        if (this.filesThumb) {
          if (this.files && this.files.length > 0) {
            this.files.unshift(this.filesThumb);
          } else if (this.filesThumb && !this.files) {
            this.listImg.push(this.filesThumb);
          }
        }
        Promise.all(
          this.listImg.map((file) => {
            return this.upload.upload(file).then((uploaded: any) => {
              return JSON.parse(uploaded._body).data;
            });
          })
        ).then((upload) => {
          this.saveProduct(data, upload);
        });
      } else {
        this.saveProduct(data);
      }
    } else {
      this.toastr.error('Sai kích thước hình ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  saveProduct(data, upload: any = []) {
    let product = <any>{};
    product = data;
    //console.log(product);
    // product.sku = this.productForm.controls['sku'].value;
    product.images = [];
    product.image = this.thumb;

    if (upload.length > 0) {
      if (this.filesThumb) {
        product.image = upload[0].url;
        if (this.files && this.files.length > 0) {
          upload.shift(); // remove thumb
        }
      }
      if (this.files && this.files.length > 0) {
        if (upload.length >= 1) {
          product.images = [];
          upload.forEach((res) => {
            product.images.push(res.url);
          });
        }
      }
    }
    if (this.attachments.length > 0) {
      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i]) {
          product.images.push(this.attachments[i]);
        }
      }
    }

    this.productService
      .createNewProduct(product)
      .toPromise()
      .then(
        (res) => {
          if (res) {
            //console.log(res);
            if (res.error) {
              //console.log(res);
              // this.message = {
              //     class: 'alert dark alert-danger',
              //     content: res.status + ' : ' + res.message
              // };
              this.toastr.error(res.status + ' : ' + res.message, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              // this.message = {
              //     class: 'alert dark alert-success',
              //     content: 'Thêm mới thành công'
              // };
              this.resetForm();
              this.toastr.success('Thêm mới sản phẩm thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.backToList.emit({
                isBack: false,
                AddSuccess: true,
              });
            }
          }
        },
        (err) => {
          // //this.message = { content: err.message, class: "alert dark alert-danger" };
          this.productService
            .getAllProduct({ code: product.sku })
            .subscribe((dataCreate) => {
              //console.log(dataCreate);
              if (dataCreate.data.products.length > 0) {
                this.toastr.error('Sản phẩm đã tồn tại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.productService
                  .getAllProduct({ code: product.sku, deleted: 1 })
                  .subscribe((data) => {
                    //console.log(data);
                    if (data.data.products.length > 0) {
                      this.confirmationService.confirm({
                        message:
                          'Sản phẩm đã bị xóa trước đó. Bạn có muốn khôi phục lại không ?',
                        header: 'Xác nhận',
                        icon: 'fa fa-trash',
                        accept: () => {
                          let dataFiler: any = {
                            ids: [[data.data.products[0].id]],
                            isRestore: true,
                          };
                          this.productService
                            .multiDelete(dataFiler)
                            .subscribe((resUpdate) => {
                              if (!resUpdate.error) {
                                this.toastr.success(
                                  'Phục hồi sản phẩm thành công',
                                  '',
                                  {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right',
                                  }
                                );
                                this.backToList.emit({
                                  isBack: false,
                                });
                              }
                            });
                        },
                      });
                    } else {
                      this.toastr.error('Sản phẩm đã tồn tại', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right',
                      });
                    }
                  });
              }
            });

          // this.toastr.error(err.message, '', {
          //     timeOut: 4000,
          //     positionClass: 'toast-bottom-right'
          // });
        }
      );
  }

  resetForm() {
    // this.productForm.reset();
    // $('#previewThumb').html('');
    // $('#previewImage').html('');
    // (<FormControl>this.productForm.controls['status']).setValue('1');
    // (<FormControl>this.productForm.controls['description']).setValue('');
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  // ck editor
  uploadCK(event, idUPload) {
    $('#' + idUPload).click();
  }

  findByBarcode(val) {
    if (val.length > 0) {
      this.productService
        .findProduct(val)
        .toPromise()
        .then((item: any) => {
          this.cloneProductIcheck(item);
        });
      this.productService
        .findProductContent(val)
        .toPromise()
        .then((res: any) => {
          if (res.data && res.data.length > 0) {
            this.proContent = res.data[0].content;
          }
        });
    }
  }

  cloneProductIcheck(res: any) {
    const data = res.data;
    const vendor = data.vendor;

    if (data.isClone) {
      (<FormControl>this.productForm.controls['name']).setValue('');
      (<FormControl>this.productForm.controls['video']).setValue('');
      (<FormControl>this.productForm.controls['price']).setValue('');
      (<FormControl>this.productForm.controls['status']).setValue('1');
      (<FormControl>this.productForm.controls['vendor']).setValue('');
      (<FormControl>this.productForm.controls['vendor_id']).setValue('');
      (<FormControl>this.productForm.controls['description']).setValue('');
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Mã Barcode không hợp lệ.',
      };
      this.scrollToTop();
    } else {
      this.message = null; // remove message
      (<FormControl>this.productForm.controls['name']).setValue(
        data.product_name
      );
      (<FormControl>this.productForm.controls['price']).setValue(
        data.price_default
      );
      (<FormControl>this.productForm.controls['status']).setValue(
        data.status ? '1' : '0'
      );
      (<FormControl>this.productForm.controls['description']).setValue(
        this.proContent
      );
      if (vendor.name) {
        (<FormControl>this.productForm.controls['vendor']).setValue(
          vendor.name
        );
      }
      if (vendor.id) {
        (<FormControl>this.productForm.controls['vendor_id']).setValue(
          vendor.id.toString()
        );
      }
      if (data.image_default.length > 0) {
        this.thumb = UtilityService.getImg(data.image_default);
        $('#previewThumb').html('');
        $('#previewThumb').append(
          '<li><div class="card card-shadow"><figure class="card-img-top overlay-hover overlay"><img class="overlay-figure overlay-scale" src="' +
          this.thumb +
          '"></figure></div></li>'
        );
      }
      this.attachments = [];
      data.attachments.forEach((att) => {
        if (att.type === 'image') {
          this.attachments.push(UtilityService.getImg(att.link));
        }
      });
      $('#previewImage').html('');
      let h = 0;
      this.attachments.forEach((atta) => {
        let idDiv = 'previewImage' + h;

        $('#previewImage').append(
          '<li><div id="' +
          idDiv +
          '" class="card card-shadow"><figure class="card-img-top overlay-hover overlay"><img class="overlay-figure overlay-scale" src="' +
          atta +
          '" alt="..." style="height: 100px; width: 150px; object-fit: cover;"></figure><i id="' +
          idDiv +
          atta +
          '" class="wb-close" style="position: absolute; top: 5px; right: 5px; color: red; font-weight: 400"></i></div></li>'
        );
        h++;
      });
      $('#previewImage').on('click', '.wb-close', function (e) {
        for (let i = 0; i < that.attachments.length; i++) {
          let idIcon = e.currentTarget.id
            .toString()
            .split('previewImage' + i)[1];
          if (idIcon === that.attachments[i]) {
            $('#' + 'previewImage' + i + '').remove();
            delete that.attachments[i];
          }
        }
      });
    }
  }

  saveToCK(event, yourEditorID) {
    const files: any[] = [];
    let filesAmount = event.target.files.length;
    let ValidImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    for (let i = 0; i < filesAmount; i++) {
      let fileType = event.target.files[i]['type'];
      let fileSize = event.target.files[i]['size'];
      if (fileSize <= 1024 * 1024) {
        if ($.inArray(fileType, ValidImageTypes) > 0) {
          // valid file type code goes here.
          files.push(event.target.files[i]);
        }
      } else {
        $('#' + yourEditorID).html(
          event.target.files[i]['name'] +
          ' có dung lượng quá 1MB. Vui lòng chọn ảnh khác'
        );
      }
    }
    Promise.all(
      files.map((file) => {
        return this.upload.upload(file).then((uploaded: any) => {
          return JSON.parse(uploaded._body).data;
        });
      })
    ).then((upload: any) => {
      upload.forEach((dta) => {
        const html = '<img src=\'' + dta.url + '\'/>';
        (<FormControl>this.productForm.controls[yourEditorID]).setValue(
          this.productForm.controls[yourEditorID].value + '<br/>' + html
        );
      });
    });
  }

  readUrl(input, message, showImage) {
    if (input.target.files) {
      let filesAmount = input.target.files.length;
      $(showImage).html('');
      $(message).html('');
      let ValidImageTypes = [
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/jpg',
      ];
      if (filesAmount <= 20) {
        for (let i = 0; i < filesAmount; i++) {
          let reader = new FileReader();
          let fileType = input.target.files[i]['type'];
          if ($.inArray(fileType, ValidImageTypes) > 0) {
            // valid file type code goes here.
            reader.onload = (event: any) => {
              $(showImage).append(
                '<li><div class="card card-shadow"><figure class="card-img-top overlay-hover overlay"><img class="overlay-figure overlay-scale" src="' +
                event.target.result +
                '" alt="..." style="height: 100px;object-fit: cover;"></figure></div></li>'
              );
            };
            $(message).html('');
          } else {
            $(message).html('');
            $(message).html('Ảnh đại diện phải có định dạng JPG, JPEG và PNG.');
          }
          reader.readAsDataURL(input.target.files[i]);
        }
      } else {
        $(message).html('');
        $(message).html('Bạn chỉ được chọn tối đa 5 ảnh.');
      }
    }
  }

  onChange(event, message, type) {
    let mFile = event.target.files;
    let filesAmount = event.target.files.length;
    let ValidImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/jpg'];
    let fileType = event.target.files[0]['type'];
    let fileSize = event.target.files[0]['size'];

    if (filesAmount <= 20) {
      if (fileSize <= 1024 * 1024) {
        if ($.inArray(fileType, ValidImageTypes) > 0) {
          switch (type) {
            case 1: {
              this.filesThumb = null;
              this.filesThumb = mFile[0];
              this.isTrueSize = true;
              break;
            }
            case 2: {
              this.files = [];
              for (const _file of event.target.files) {
                this.files.push(_file);
              }
              this.isTrueSize = true;
              break;
            }
          }
        }
        $(message).html('');
      } else {
        $(message).html('');
        $(message).html(
          'Dung lượng ảnh không được quá 1MB. Vui lòng chọn ảnh khác'
        );
        this.isTrueSize = false;
      }
    } else {
      $(message).html('');
      $(message).html('Bạn chỉ được chọn tối đa 5 ảnh.');
      this.isTrueSize = false;
    }
  }

  getCountries() {
    this.addressService.getCountries().subscribe((res) => {
      const list: Array<any> = [];
      for (const _data of res.data.countries) {
        const obj = {
          value: _data.id.toString(),
          label: _data.name,
          image: _data.ensign,
        };
        list.push(obj);
      }
      this.countries = list;
    });
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
      if (this.vendor.address) {
        let addressString = this.vendor.address.split(', ');
        let address = '';
        if (addressString.length >= 3) {
          for (let h = 0; h < addressString.length - 2; h++) {
            address += addressString[h];
          }
          this.vendorAdd.address = address;
          for (let i = 0; i < this.cities.length; i++) {
            let index = addressString[addressString.length - 1]
              .toString()
              .indexOf(this.cities[i].value);
            if (index >= 0) {
              this.vendorAdd.city_id = this.cities[i].id;
              this.loadDistrictData(
                this.vendorAdd.city_id,
                addressString[addressString.length - 2]
              );
            }
          }
        } else {
          this.vendorAdd.address = this.vendor.address;
        }
      }
    });
  }

  loadDistrictData(id: number, district: any) {
    if (this.vendorAdd.city_id) {
      this.addressService
        .getDistrict({ city_id: this.vendorAdd.city_id })
        .toPromise()
        .then((res) => {
          const districts = [];
          res.data.districts.forEach((c: any) => {
            districts.push({
              value: c.name,
              label: c.name,
              id: c.id,
            });
          });
          this.districts = districts;
          if (district) {
            for (let i = 0; i < this.districts.length; i++) {
              let index = district.toString().indexOf(this.districts[i].value);
              if (index >= 0) {
                this.vendorAdd.district_id = this.districts[i].id;
              }
            }
          }
        });
    }
  }

  loadListVendor() {
    this.productService.loadListVendor(undefined).subscribe((res) => {
      this.vendors = res.data;
      for (let i = 0; i < this.vendors.length; i++) {
        if (this.vendors[i].name.length >= 50) {
          this.vendors[i].name = this.vendors[i].name.slice(0, 50) + ' ...';
        }
      }
    });
  }

  addNewVendor(status: any) {
    if (status == true) {
      if (this.product.vendor_id) {
        delete this.product.vendor_id;
      }
      this.vendorAdd.name = this.vendor.name;
      if (this.vendor.phone && this.vendor.phone != '') {
        this.vendorAdd.phone = this.vendor.phone;
      }
      if (this.vendor.email && this.vendor.email != '') {
        this.vendorAdd.email = this.vendor.email;
      }
      this.vendorAdd.country_id = this.vendor.country_id;
      if (this.vendor.website && this.vendor.website != '') {
        this.vendorAdd.website = this.vendor.website;
      }
      if (this.vendor.description && this.vendor.description != '') {
        this.vendorAdd.description = this.vendor.description;
      }
      if (this.vendor.gln_code && this.vendor.gln_code != '') {
        this.vendorAdd.gln_code = this.vendor.gln_code;
      }
      if (this.vendor.country_id && this.vendor.country_id != '') {
        this.selectedCountry = this.vendor.country_id.toString();
      }

      this.getCity();
      this.vendorAddressShow = this.vendor.address;
    } else {
      this.getDataVendor();
    }
  }

  getDataVendor() {
    if (this.vendor) {
      if (this.vendor.name) {
        this.productService
          .loadListVendor({ name: this.vendor.name })
          .subscribe((res) => {
            if (res.data.length > 0) {
              this.product.vendor_id = res.data[0].id;
              //this.vendorAdd = res.data[0];
            }
          });
      }
    }
    // this.vendorAdd.name = this.vendor.name;
    // this.vendorAdd.address = this.vendor.address;
    // this.vendorAdd.name = this.vendor.name;
    // this.vendorAdd.name = this.vendor.name;
    // this.vendorAdd.name = this.vendor.name;
  }

  appendImageToShow(prefix: any) {
    const src = this.imageService.readSrcImage(prefix, 'thumb_large');
    let id = this.ramdomID();
    while (this.listIndexImage.indexOf(id) > -1) {
      id = this.ramdomID();
    }
    this.currentNumberImage++;
    let listProductImage = $('#listProductImage');
    listProductImage.append(
      `<div id="` +
      'image' +
      id +
      `" style="float: left; position: relative" class="qr-item-image">
      <img id="` +
      'itemImg' +
      id +
      `" src="` +
      src +
      `" alt="" />
      <i id="` +
      'closeImg' +
      id +
      `" class="icon wb-close" style="position: absolute; top: 5px; right: 5px; cursor: pointer;"></i>
      </div>`
    );
    this.listIndexImage.push(id);
    $('#' + 'closeImg' + id.toString()).click(function (res) {
      let index = parseInt(
        res.currentTarget.id.toString().split('closeImg')[1]
      );
      for (let i = 0; i < that.listIndexImage.length; i++) {
        if (that.listIndexImage[i] == index) {
          $('#' + 'image' + index.toString()).remove();
          that.listIndexImage.splice(i, 1);
          that.currentNumberImage--;
        }
      }

      //  $("#" + "image" + that.currentNumberImage.toString()).remove();
      // that.currentNumberImage--;
    });
  }

  ramdomID() {
    return Math.floor(Math.random() * 5 + 1);
  }

  loadProduct() {
    if (this.barcode && this.barcode != '') {
      this.productService
        .findProduct(this.barcode)
        .toPromise()
        .then((item: any) => {
          //console.log(item);
          if (!item.isClone) {
            this.product.sku = item.data.gtin_code;
            this.product.name = item.data.product_name;
            if (this.listIndexImage.length >= 1) {
              for (let i = 0; i < this.listIndexImage.length; i++) {
                $('#' + 'image' + this.listIndexImage[i]).remove();
              }
              this.currentNumberImage = 0;
              this.product.images = [];
              this.listIndexImage = [];
            }
            if (item.data.image_default) {
              let thumb = UtilityService.getImg(item.data.image_default);
              this.product.images.push(thumb);
              if (item.data.attachments) {
                for (let i = 0; i < item.data.attachments.length; i++) {
                  if (
                    item.data.attachments[i].link !== item.data.image_default
                  ) {
                    const image = UtilityService.getImg(
                      item.data.attachments[i].link
                    );
                    this.product.images.push(image);
                  }
                }
              }
            } else {
              if (item.data.attachments) {
                for (let i = 0; i < item.data.attachments.length; i++) {
                  const image = UtilityService.getImg(
                    item.data.attachments[i].link
                  );
                  this.product.images.push(image);
                }
              }
            }
            let indexUpload = 0;
            for (let h = 0; h < this.product.images.length; h++) {
              if (5 - this.currentNumberImage > 0) {
                indexUpload++;
                this.appendImageToShow(this.product.images[h]);
              }
            }
            this.product.price = item.data.price_default;
            //console.log(this.product);
          }
          if (Object.keys(item.data).length > 1) {
            this.vendor = item.data.vendor;
            //console.log(this.vendor);
            this.getDataVendor();
            // this.productService.findProductContent(this.barcode).toPromise().then((res: any) => {
            //   console.log(res);
            //   this.productAttributes = res.data;
            // });
          }
        });
    }
  }

  // addInfos() {
  //   this.idInfo++;
  //   let id = this.ramdomInfoID(this.idInfo);
  //   while (this.listInfos.indexOf(id) > -1) {
  //     id = this.ramdomInfoID(this.idInfo);
  //   }
  //   let infomations = $("#productInfomations");
  //   infomations.append(
  //     `<div id="` +
  //       "info" +
  //       id +
  //       `" class="form-horizontal p-10 pl-30 pr-30 mb-15" style="border: 1px solid #dcdcdc; position: relative;">
  //       <div class="form-group row">
  //         <label class="col-md-12">Tiêu đề: <span style="color: red;">(*) Tối đa 255 ký tự</span></label>
  //         <div class="col-md-12">
  //           <input id="` +
  //       "titleInfo" +
  //       id +
  //       `" type="text" class="form-control form-control-sm" placeholder="" autocomplete="off">
  //           <span id="` +
  //       "errorTitle" +
  //       id +
  //       `" style="color: red"></span>
  //         </div>
  //       </div>
  //       <div class="form-group row">
  //         <label class="col-md-12">Nội dung: <span style="color: red;">(*)</span></label>
  //         <div class="col-md-12">
  //           <div id="` +
  //       "contentInfo" +
  //       id +
  //       `" style="height: 300px"></div>
  //           <span id="` +
  //       "errorContent" +
  //       id +
  //       `" style="position: absolute; bottom: 0px; color: red"></span>
  //         </div>
  //       </div>
  //       <i id="` +
  //       "close" +
  //       id +
  //       `" class="icon wb-close" style="position: absolute; top: 5px; right: 5px; cursor: pointer;"></i>
  //     </div>`
  //   );
  //   $("#" + "contentInfo" + id).summernote();
  //   this.listInfos.push(id);
  //   $("#" + "close" + id.toString()).click(function (res) {
  //     let index = parseInt(res.currentTarget.id.toString().split("close")[1]);
  //     for (let i = 0; i < that.listInfos.length; i++) {
  //       if (that.listInfos[i] == index) {
  //         $("#" + "info" + index.toString()).remove();
  //         that.listInfos.splice(i, 1);
  //         that.idInfo--;
  //       }
  //     }
  //   });
  //   $("#" + "titleInfo" + id.toString()).focusout(function () {
  //     if (
  //       $("#" + "titleInfo" + id.toString()).val().length > 255 ||
  //       $("#" + "titleInfo" + id.toString()).val().length == ""
  //     ) {
  //       $("#" + "errorTitle" + id.toString()).text(
  //         "Tiêu đề tối thiểu là 1 ký tự và tối đa là 255 ký tự"
  //       );
  //     } else {
  //       $("#" + "errorTitle" + id.toString()).text("");
  //     }
  //   });
  //   $("#" + "contentInfo" + id)[0].parentNode.children[1].id = "editor" + id;
  //   $("#" + "editor" + id + " .note-editing-area .note-editable").focusout(
  //     () => {
  //       if (
  //         $("#" + "contentInfo" + id.toString()).summernote("code") ==
  //           "<p><br></p>" ||
  //         $("#" + "contentInfo" + id.toString()).summernote("code").length == ""
  //       ) {
  //         $("#" + "errorContent" + id.toString()).text(
  //           "Nội dung không được để trống"
  //         );
  //       } else {
  //         $("#" + "errorContent" + id.toString()).text("");
  //       }
  //     }
  //   );
  // }

  countInfos: number = 1;
  arrCountInfos: any = [this.countInfos];
  arrContent: any = [
    {
      id: new Date().getTime(),
      title: '',
      image: null,
      content: null,
    },
  ];

  addInfos1() {
    const objectAdd = {
      id: new Date().getTime(),
      title: '',
      content: null,
      image: null,
    };
    this.arrContent.push(objectAdd);
    setTimeout(() => {
      $('.cke_button__image').hide();
      $(`.test${objectAdd.id} .cke_button__link`)
        .parent()
        .append(
          `<a style="display: inline-block;padding: 4px;"><span class="cke_button_icon cke_button__image_icon" style="background-image:url('https://cdn.ckeditor.com/4.14.0/standard-all/plugins/icons.png?t=K24B');background-position:0 -1224px;background-size:auto;">&nbsp;</span></a>`
        );
      $(`.test${objectAdd.id} .cke_button_icon.cke_button__image_icon`).click(
        () => {
          let loca = this.arrContent.find((item) => item.id == objectAdd.id);
          if (loca) {
            this.currentContentIndex = this.arrContent.findIndex(
              (gg) => gg.id == loca.id
            );
          }
          this.modalRef = this.modalService.show(this.uic);
        }
      );
    }, 500);
  }

  removeInfo(i) {
    this.arrContent.splice(i, 1);
  }

  ckeImageUrl: string = '';

  addCkeImageUrl() {
    if (this.ckeImageUrl) {
      this.arrContent[
        this.currentContentIndex
      ].content += `<img src="${this.ckeImageUrl}">`;
      this.ckeImageUrl = '';
    }
    this.modalRef.hide();
  }

  deleteIcon(index: number) {
    this.arrContent[index].image = null;
  }

  ramdomInfoID(max) {
    return Math.floor(Math.random() * max + 1);
  }

  readUrlImagesUpload(event: any) {
    let fileUpload: any = [];
    let files: any = [];
    files = event.srcElement.files;
    let ValidImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (this.currentNumberImage >= 5) {
      this.toastr.warning('Số lượng hình ảnh đã đạt tối đa', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      if (files.length > 0) {
        if (files.length < 20 - this.currentNumberImage) {
          for (let i = 0; i < files.length; i++) {
            if (files[i].size > 1024 * 1024) {
              this.toastr.error(
                'Kích thước hình ảnh ' +
                files[i].name +
                ' đã vượt quá 1MB, vui lòng chọn ảnh khác',
                '',
                {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                }
              );
            } else {
              if ($.inArray(files[i].type, ValidImageTypes) > 0) {
                fileUpload.push(files[i]);
              } else {
                this.toastr.error(
                  'Định dạng hình ảnh không phù hợp, vui lòng chọn ảnh khác',
                  '',
                  {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  }
                );
                return;
              }
            }
          }
        } else {
          for (let i = 0; i < 20 - this.currentNumberImage; i++) {
            if (files[i].size > 1024 * 1024) {
              this.toastr.error(
                'Kích thước hình ảnh ' +
                files[i].name +
                ' đã vượt quá 1MB, vui lòng chọn ảnh khác',
                '',
                {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                }
              );
            } else {
              if ($.inArray(files[i].type, ValidImageTypes) > 0) {
                fileUpload.push(files[i]);
              } else {
                this.toastr.error(
                  'Định dạng hình ảnh không phù hợp, vui lòng chọn ảnh khác',
                  '',
                  {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  }
                );
                return;
              }
            }
          }
        }
        Promise.all(
          fileUpload.map((file) => {
            return this.upload.upload(file).then((uploaded: any) => {
              return JSON.parse(uploaded._body).data;
            });
          })
        ).then((upload: any) => {
          upload.forEach((dta) => {
            console.log(dta);
            this.appendImageToShow(dta.prefix);
            this.product.images.push(dta.prefix);
          });
        });
      }
    }
  }

  /*Ham them anh vao mang*/
  images = [];
  tusUpload = (item) => {
    const numberImages = item.target.files.length;
    if (numberImages > 5) {
      this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {
        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            if (this.images.length >= 5) {
              this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.images.push(image2);
            }
          }
        });

      }
    }
  };

  tusUploadIcon = (item: any, index: any) => {
    const numberImages = item.target.files.length;
    if (numberImages > 1) {
      this.toastr.error('Chỉ được upload tối đa 1 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            this.arrContent[index].image = image2.url;

          }
        });

      }
    }
  };

  ckeContent = [];
  imgUploadCke = (item) => {
    const numberImages = item.target.files.length;
    if (numberImages > 20) {
      this.toastr.error('Chỉ được upload tối đa 20 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            this.arrContent[
              this.currentContentIndex
            ].content += `<img src="${image2.url}">`;
          }
        });

      }
      this.modalRef.hide();
    }
  };

  /*Ham xoa anh*/
  deleteImage(id) {
    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i].id === id) {
        this.images.splice(this.images.indexOf(this.images[i]), 1);
        break;
      }
    }
  }

  async addNewProduct() {

    this.isAdding = true;
    setTimeout(() => {
      this.isAdding = false;
    }, 2000);

    if (this.productForm.value.is_maintenance_reminder) {
      if (!this.productForm.value.maintenance_cycle || parseInt(this.productForm.value.maintenance_cycle, 10) <= 0) {
        this.toastr.warning('Vui lòng nhập thời gian thông báo bảo trì lớn hơn 0', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        this.isAdding = false;
        return;
      }
    }

    if (this.productForm.value.is_expired_reminder) {
      if (!this.productForm.value.expired_cycle || parseInt(this.productForm.value.expired_cycle, 10) <= 0) {
        this.toastr.warning('Vui lòng nhập thời gian thông báo hết hạn bảo hành lớn hơn 0', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        this.isAdding = false;
        return;
      }
    }

    if (this.productForm.value.is_extend_maintenance && this.productForm.value.maintenance_mode === 'recurring') {
      if (!this.productForm.value.extend_limit || parseInt(this.productForm.value.extend_limit, 10) <= 0) {
        this.toastr.warning('Vui lòng nhập giới hạn số lần gửi sau khi hết hạn BH lớn hơn 0', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        this.isAdding = false;
        return;
      }
    }
    const product: any = {};
    let productInfo: any = {};
    let infos: any = [];
    /**Chinh comment */
    // var images: any = [];
    // for (let i = 0; i < this.listIndexImage.length; i++) {
    //   var img = $("#" + "itemImg" + this.listIndexImage[i].toString()).attr(
    //     "src"
    //   );
    //   images.push(this.imageService.getFrefixFromUrl(img));
    // }
    // product.images = images;
    /**Chinh comment */
    /*push id images into array product.images*/
    const imageIds = [];
    this.images.map((item) => {
      imageIds.push(item.url);
    });
    product.images = imageIds;
    /*End push id images*/
    if (product.images.length < 1) {
      this.toastr.error('Hình ảnh tối tiểu phải là 1', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    let hasWrongTitle = 0;
    let hasWrongContent = 0;
    for (let i = 0; i < this.listInfos.length; i++) {
      const info: any = {};
      info.title = $('#' + 'titleInfo' + this.listInfos[i].toString()).val();
      info.content = $(
        '#' + 'contentInfo' + this.listInfos[i].toString()
      ).summernote('code');
      if (info.title.length > 255 || info.title == '') {
        hasWrongTitle++;
        $('#' + 'errorTitle' + this.listInfos[i].toString()).text(
          'Tiêu đề tối thiểu là 1 ký tự và tối đa là 255 ký tự'
        );
      }
      if (info.content == '<p><br></p>' || info.content == '') {
        hasWrongContent++;
        $('#' + 'errorContent' + this.listInfos[i].toString()).text(
          'Nội dung không được để trống'
        );
      }
      if (
        info.title != '' &&
        info.title.length <= 255 &&
        info.content != '<p><br></p>' &&
        info.content != ''
      ) {
        infos.push(info);
      }
    }
    if (hasWrongTitle > 0 || hasWrongContent > 0) {
      this.toastr.warning('Thông tin chi tiết sản phẩm không hợp lệ', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    product.infos = infos;
    if (this.barcode && this.barcode != '') {
      product.sku = this.barcode;
    }

    if (
      this.product.internal_name &&
      this.product.internal_name.trim() !== ''
    ) {
      product.internal_name = this.product.internal_name.trim();
    }

    if (!this.product.name || this.product.name == '') {
      // this.toastr.warning('Tên sản phẩm không được để trống', '', {
      this.toastr.warning('Tên hiển thị không được để trống', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    if (this.product.name && this.product.name != '') {
      if (this.product.name.length > 100) {
        // this.toastr.warning('Tên sản phẩm quá dài', '', {
        this.toastr.warning('Tên hiển thị quá dài', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      } else {
        product.name = this.product.name;
      }
    }

    if (!this.is_use_time) {
      this.product.use_time_type = null;
      this.product.use_time_count = null;
    }

    product.use_time_count = this.product.use_time_count;
    product.use_time_type = this.product.use_time_type;

    const mapMode = (mode: string) => mode === 'once' ? 'ONCE' : 'REPEAT';
    const mapUnit = (unit: string) => unit === 'days' ? 'DAY' : (unit === 'months' ? 'MONTH' : 'YEAR');

    let warranty_reminder_config: any = {};

    if (this.productForm.value.is_maintenance_reminder) {
      warranty_reminder_config.reminderMaintain = {
        isSelect: true,
        mode: mapMode(this.productForm.value.maintenance_mode),
        reminderContinue: this.productForm.value.is_extend_maintenance,
        numberTimeNotify: this.productForm.value.maintenance_cycle ? parseInt(this.productForm.value.maintenance_cycle, 10) : null,
        timeType: mapUnit(this.productForm.value.maintenance_cycle_unit)
      };
      if (this.productForm.value.maintenance_mode !== 'once' && this.productForm.value.is_extend_maintenance && this.productForm.value.extend_limit) {
        warranty_reminder_config.reminderMaintain.numberOfLimit = parseInt(this.productForm.value.extend_limit, 10);
      }
    } else {
      warranty_reminder_config.reminderMaintain = { isSelect: false };
    }

    if (this.productForm.value.is_expired_reminder) {
      warranty_reminder_config.reminderExpired = {
        isSelect: true,
        mode: mapMode(this.productForm.value.expired_mode),
        reminderContinue: false,
        numberTimeNotify: this.productForm.value.expired_cycle ? parseInt(this.productForm.value.expired_cycle, 10) : null,
        timeType: mapUnit(this.productForm.value.expired_cycle_unit),
        numberOfLimit: 1
      };
    } else {
      warranty_reminder_config.reminderExpired = { isSelect: false };
    }

    product.warranty_reminder_config = warranty_reminder_config;

    if (!this.product.price || this.product.price == '') {
      this.product.price = null;
      product.price = null;
    } else if (this.product.price && this.product.price != '') {
      product.price = this.product.price;
    }
    if (this.product.video && this.product.video != '') {
      product.video = this.product.video;
    }
    product.vendor = {};
    let countInvalidContent: number = 0;

    if (this.arrContent.length === 0) {

      return this.toastr.warning('Thông tin sản phẩm không để trống', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      console.log('mang', this.arrContent);
      let tmpInfo = [];
      this.arrContent.forEach((item, index) => {
        if (item.title == '' || item.title.length > 255) {
          $(`.form-group#${index} .text-danger-alert`).text(
            'Tiêu đề tối thiểu là 1 ký tự và tối đa là 255 ký tự'
          );
          countInvalidContent += 1
        } else {
          $(`.form-group#${index} .text-danger-alert`).text('');
          countInvalidContent = 0

        }

        if (
          item.content == '<p><br></p>' ||
          item.content == '' ||
          !item.content
        ) {
          $(`.text-danger-cke-${index}`).text('Nội dung không được để trống');
          countInvalidContent += 1;
        } else {
          $(`.text-danger-cke-${index}`).text('');
          countInvalidContent = 0;
        }

        if (
          item.title &&
          item.title.trim() != '' &&
          item.title.length <= 255 &&
          item.content &&
          item.content.trim() != '<p><br></p>' &&
          item.content.trim() != ''
        ) {
          tmpInfo.push({
            title: item.title,
            content: item.content,
            image: item.image,
          });
          product.infos = tmpInfo;
          console.log(tmpInfo);

        } else {
          return this.toastr.warning('Thông tin sản phẩm chưa hợp lệ', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      });
    }

    if (this.isAddVendor == true) {
      this.product.vendor = this.vendorAdd;
      if (!this.product.vendor.name || this.product.vendor.name == '') {
        this.toastr.warning('Tên nhà cung không được để trống', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
      if (!this.product.vendor.address || this.product.vendor.address == '') {
        this.toastr.warning('Địa chỉ nhà cung không được để trống', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }

      if (this.selectedCountry && this.selectedCountry != '') {
        this.vendorAdd.country_id = parseInt(this.selectedCountry);
      }
      if (this.vendorAdd.gln_code && this.vendorAdd.gln_code != '') {
        product.vendor.gln_code = this.vendorAdd.gln_code;
      }
      if (this.vendorAdd.name && this.vendorAdd.name != '') {
        product.vendor.name = this.vendorAdd.name;
      }
      if (this.vendorAdd.country_id && this.vendorAdd.country_id != '') {
        product.vendor.country_id = this.vendorAdd.country_id;
      }
      if (this.vendorAdd.address && this.vendorAdd.address != '') {
        product.vendor.address = this.vendorAdd.address;
      }
      if (this.vendorAdd.city_id && this.vendorAdd.city_id != '') {
        product.vendor.city_id = this.vendorAdd.city_id;
      }
      if (this.vendorAdd.district_id && this.vendorAdd.district_id != '') {
        product.vendor.district_id = this.vendorAdd.district_id;
      }
      if (this.vendorAdd.phone && this.vendorAdd.phone != '') {
        product.vendor.phone = this.vendorAdd.phone;
      }
      if (this.vendorAdd.email && this.vendorAdd.email != '') {
        product.vendor.email = this.vendorAdd.email;
      }
      if (this.vendorAdd.website && this.vendorAdd.website != '') {
        product.vendor.website = this.vendorAdd.website;
      }
      if (this.vendorAdd.description && this.vendorAdd.description != '') {
        product.vendor.description = this.vendorAdd.description;
      }

      if (
        product.vendor.name &&
        product.vendor.name != '' &&
        product.vendor.address &&
        product.vendor.address != '' &&
        product.name &&
        product.name != '' &&
        product.images.length > 0 &&
        hasWrongTitle == 0 &&
        hasWrongContent == 0 &&
        product.infos && product.infos.length &&
        countInvalidContent === 0
      ) {
        if (this.filesAttach.length > 0 || this.filesAttachFake.length > 0) {
          const dataFile = await this.uploadFiles()
          console.log('dataFile222', dataFile)

          if (this.filesAttach.length > 0) {
            product.attachments = [];
            if (dataFile.attach.length > 0) {
              dataFile.attach.forEach((att) => {
                product.attachments.push(att.url);
              });
            }
          }


          if (this.filesAttachFake.length > 0) {
            product.fake_attachments = [];
            if (dataFile.attachFake.length > 0) {
              dataFile.attachFake.forEach((att) => {
                product.fake_attachments.push(att.url);
              });
            }
          }


          this.productService.createNewProduct(product).subscribe((res) => {
            if (res.error) {
              this.toastr.error('Thêm mới sản phẩm thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.toastr.success('Thêm mới sản phẩm thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.backToList.emit({
                isBack: false,
                AddSuccess: true,
              });
            }
          }, (error) => {
            this.toastr.error('Thêm mới sản phẩm thất bại ', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            })
          });
        } else {
          this.productService.createNewProduct(product).subscribe((res) => {
            if (res.error) {
              this.toastr.error('Thêm mới sản phẩm thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.toastr.success('Thêm mới sản phẩm thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.backToList.emit({
                isBack: false,
                AddSuccess: true,
              });
            }
          }, (error) => {
            this.toastr.error('Thêm mới sản phẩm thất bại ', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            })
          });
        }
      }
    } else {
      if (!this.product.vendor_id || this.product.vendor_id == '') {
        this.toastr.warning('Phải lựa chọn nhà sản xuất', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      } else {
        product.vendor_id = this.product.vendor_id;
      }
      if (
        product.name &&
        product.name != '' &&
        product.vendor_id &&
        product.vendor_id != '' &&
        product.images.length > 0 &&
        hasWrongTitle == 0 &&
        hasWrongContent == 0 &&
        product.infos &&
        product.infos.length &&
        countInvalidContent === 0
      ) {
        if (this.filesAttach.length > 0 || this.filesAttachFake.length > 0) {

          const dataFile = await this.uploadFiles()
          console.log('dataFile111', dataFile)
          if (this.filesAttach.length > 0) {
            product.attachments = [];
            if (dataFile.attach.length > 0) {
              dataFile.attach.forEach((att) => {
                product.attachments.push(att.url);
              });
            }
          }

          if (this.filesAttachFake.length > 0) {
            product.fake_attachments = [];
            if (dataFile.attachFake.length > 0) {
              dataFile.attachFake.forEach((att) => {
                product.fake_attachments.push(att.url);
              });
            }
          }
          this.productService.createNewProduct(product).subscribe((res) => {
            if (res.error) {
              this.toastr.error('Thêm mới sản phẩm thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.toastr.success('Thêm mới sản phẩm thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.backToList.emit({
                isBack: false,
                AddSuccess: true,
              });
            }
          }, (error) => {
            this.toastr.error('Thêm mới sản phẩm thất bại', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            })
          });
        } else {
          this.productService.createNewProduct(product).subscribe((res) => {
            if (res.error) {
              this.toastr.error('Thêm mới sản phẩm thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.toastr.success('Thêm mới sản phẩm thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.backToList.emit({
                isBack: false,
                AddSuccess: true,
              });
            }
          }, (error) => {
            this.toastr.error('Thêm mới sản phẩm thất bại', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            })
          });
        }
      }
    }
  }

  async uploadFiles() {
    let attach: any = [];
    let attachFake: any = [];
    if (this.filesAttach.length > 0) {
      await Promise.all(
        this.filesAttach.map((attach) => {
          return this.upload
            .uploadFileAttach(attach)
            .then((attached: any) => {
              return JSON.parse(attached._body).data;
            });
        })
      ).then((attached) => {
        attach = attached
      });
    }
    if (this.filesAttachFake.length > 0) {
      await Promise.all(
        this.filesAttachFake.map((attach) => {
          return this.upload
            .uploadFileAttach(attach)
            .then((attached: any) => {
              return JSON.parse(attached._body).data;
            });
        })
      ).then((attached) => {
        attachFake = attached

      });
    }
    return {
      attach: attach,
      attachFake: attachFake
    }
    // ...
  }

  readFileAttach(event) {
    //this.filesAttach = [];
    // this.getAttachments();
    let files = event.srcElement.files;
    //var listFileAttach: any = [];
    let ValidImageTypes = [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/pdf',
      'image/gif',
      'image/jpeg',
      'image/png',
      'image/jpg',
    ];
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (files[i]) {
          if (this.filesAttachName.length > 5) {
            this.toastr.warning(
              'Một sản phẩm chỉ cho phép tải lên tối đa 5 File',
              '',
              {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              }
            );
            return;
          }
          if (files[i].size > 5 * 1024 * 1024) {
            this.toastr.warning(
              'Kích thước File' + files[i].name + 'quá lớn',
              '',
              {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              }
            );
            return;

          }
          if (ValidImageTypes.indexOf(files[i].type) < 0) {
            this.toastr.warning('File' + files[i].name + ' sai định dạng', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            return;

          }
          if (
            ValidImageTypes.indexOf(files[i].type) >= 0 &&
            files[i].size <= 5 * 1024 * 1024 &&
            this.filesAttachName.length < 5
          ) {
            this.filesAttach.push(files[i]);
            let filename = '';
            if (files[i].name.length > 30) {
              filename =
                files[i].name.slice(0, 20) +
                ' ... ... ' +
                files[i].name.slice(
                  files[i].name.length - 9,
                  files[i].name.length
                );
            } else {
              filename = files[i].name;
            }

            let item = {
              link: null,
              show: filename,
              name: files[i].name,
              isAdd: true,
            };
            this.filesAttachName.push(item);
          }
        }
      }
    }
  }

  readFileAttachFake(event) {
    //this.filesAttach = [];
    // this.getAttachments();
    let files = event.srcElement.files;
    //var listFileAttach: any = [];
    let ValidImageTypes = [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/pdf',
      'image/gif',
      'image/jpeg',
      'image/png',
      'image/jpg',
    ];
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (files[i]) {
          if (this.filesAttachNameFake.length > 5) {
            this.toastr.warning(
              'Một sản phẩm chỉ cho phép tải lên tối đa 5 File',
              '',
              {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              }
            );
            return;
          }
          if (files[i].size > 5 * 1024 * 1024) {
            this.toastr.warning(
              'Kích thước File' + files[i].name + 'quá lớn',
              '',
              {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              }
            );
            return;

          }
          if (ValidImageTypes.indexOf(files[i].type) < 0) {
            this.toastr.warning('File' + files[i].name + ' sai định dạng', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            return;

          }

          if (
            ValidImageTypes.indexOf(files[i].type) >= 0 &&
            files[i].size <= 5 * 1024 * 1024 &&
            this.filesAttachNameFake.length < 5
          ) {
            this.filesAttachFake.push(files[i]);
            let filename = '';
            if (files[i].name.length > 30) {
              filename =
                files[i].name.slice(0, 20) +
                ' ... ... ' +
                files[i].name.slice(
                  files[i].name.length - 9,
                  files[i].name.length
                );
            } else {
              filename = files[i].name;
            }

            let item = {
              link: null,
              show: filename,
              name: files[i].name,
              isAdd: true,
            };
            this.filesAttachNameFake.push(item);
          }

        }
      }
    }
  }

  deleteFile(index) {
    let itemIndex = this.filesAttachName[index];
    let found = this.filesAttach.findIndex(function (element) {
      let index;
      if (element.name === itemIndex.name) {
        return element;
      }
    });
    //var indexFile = this.filesAttach.indexOf(found);
    this.filesAttach.splice(found, 1);
    this.filesAttachName.splice(index, 1);
  }

  deleteFileFake(index) {
    let itemIndex = this.filesAttachNameFake[index];
    let found = this.filesAttachFake.findIndex(function (element) {
      let index;
      if (element.name === itemIndex.name) {
        return element;
      }
    });
    //var indexFile = this.filesAttach.indexOf(found);
    this.filesAttachFake.splice(found, 1);
    this.filesAttachNameFake.splice(index, 1);
  }

  ngOnDestroy() {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product_add.component.ts